import { channelResource } from '@/api'

const state = {
  loading: false,
  channels: []
}

const getters = {
  channels: (state) => {
    return state.channels
  }
}

const actions = {
  loadChannels ({ commit }) {
    commit('SET_LOADING', true)

    channelResource.all().then(res => {
      commit('SET_CHANNELS', res.data.returnValue)
      commit('SET_LOADING', false)
    }).catch(err => {
      console.log(err)
    })
  },

  addChannel ({ commit }, channel) {
    channelResource.create(channel).then((res) => {
      commit('ADD_CHANNEL', res.data.returnValue)
    })
  },

  removeChannel ({ commit }, channel) {
    // channelResource.destroy(channel.channelId).then(() => {
    commit('REMOVE_CHANNEL', channel)
    // })
  },

  clearChannels ({ commit }) {
    commit('SET_CHANNELS', [])
  }
}

const mutations = {
  SET_LOADING (state, isLoading) {
    state.loading = isLoading
  },

  SET_CHANNELS (state, channels) {
    state.channels = channels
  },

  ADD_CHANNEL (state, channel) {
    state.channels.push(channel)
  },

  REMOVE_CHANNEL (state, channel) {
    let i = state.channels.map(item => item.channelId).indexOf(channel.channelId)
    state.channels.splice(i, 1)
  }
}

export default { namespaced: true, state, getters, actions, mutations }
